import PropTypes from 'prop-types';
import { PureComponent } from 'react';
//-*- mode: jsx;-*-

import {LoadingEllipsis} from "./LoadingEllipsis.js";

export class SubmitButton extends PureComponent {

	render() {
		var buttonClass = (this.props.disabled) ? "disabled" : "";
		if (this.props.loading) {
			return <LoadingEllipsis />;
		} else {
			return <input type="submit" className={`button-primary ${buttonClass}`} value={this.props.buttonText} />;
		}
	}
}

SubmitButton.propTypes = {
	buttonText: PropTypes.string.isRequired,
	loading: PropTypes.bool,
	disabled: PropTypes.bool
};

SubmitButton.defaultProps = {
	loading: false,
	disabled: false
};

